import React from 'react';
import './Search.css';

const Skills = ()=>{
  return (
    <section className="section" id="container__skills">
      <div className="TestimonialWrapper__CurveWrapper TestimonialWrapper__TopCurveWrapper">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 440 52" transform="scale(1)" translatey={'2px'}  className="TestimonialWrappercurves__Svg">
          <path
            d="M220 1C133.228-1.86 0 33 0 33v18.5h439.5V12s-24.077 14.898-41 21C331.878 57.02 290.781 3.333 220 1z">
          </path>
        </svg>
      </div>
      <div className="TestimonialWrapper__Backdrop skills">
        <div className="container">
          <div className="sec-title centered" data-aos="fade-up" data-aos-easing="ease-in-sine">
            <h2>My Skills</h2>
          </div>
          <div className="row">
            <div className="col-md-8 col-sm-8">
              <p className="Paragraph-sc-1tzuhix-0" data-aos="fade-right">
                Through my studies, I've gained a solid understanding of computer science and web
                development concepts, and have dedicated a lot of my free time to apply these concepts to
                real-world scenarios and applications.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="pages__SkillTable-sc-6kvjaa-1">
                <div data-aos="fade-left">
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> HTML & CSS</p>
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> PHP &amp; MYSQL</p>
                </div>
                <div data-aos="fade-left">
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> Java</p>
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> Angular</p>
                </div>
                <div data-aos="fade-left">
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> React</p>
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> SASS</p>
                </div>
                <div data-aos="fade-left">
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> Node.js</p>
                  <p className="Paragraph-sc-1tzuhix-0"><span>○</span> NestJS</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="TestimonialWrapper__CurveWrapper TestimonialWrapper__BottomCurveWrapper">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 441 73" translatey={'-2px'} transform="scale(1)" className="TestimonialWrappercurves__Svg">
          <path
            d="M133 39.5C80.795 39.858 0 26 0 26V0h440.5v51.5S427.546 62.233 418 67c-49.342 24.641-78.218-41.116-133-47.5-59.469-6.93-92.13 19.589-152 20z">
          </path>
        </svg>
      </div>
    </section>
  );
}
export default Skills;